import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import { NavLink } from 'react-router-dom';

export default class Ticket extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            data: null,
            loading: true,
            message: '',
            attachmentFileName: '',
            attachment: ''
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/ticket/get", {
            id: this.getCurrentFormId(),
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.setState({
                        data: data,
                        loading: false
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        e.preventDefault();
        this.httpPost("api/v1/ticket/save", {
            id: this.getCurrentFormId(),
            status: this.state.data.record.status,
            topic: this.state.data.record.topic,
            message: this.state.message,
            attachmentFileName: this.state.attachmentFileName,
            attachment: this.state.attachment
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.setState({
                        redirect: '/tickets/'
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    closeTicket() {
        this.httpPost("api/v1/ticket/close", {
            id: this.getCurrentFormId()
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("تیکت با موفقیت بسته شد");
                    this.setState({
                        redirect: '/tickets/'
                    })
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setAttachment(_file) {
        this.getBase64(_file).then(file => {
            this.state.attachment = file;
            this.state.attachmentFileName = _file.name;
        });
    }
    showJsonMessage(msg) {
        var content = JSON.parse(msg.message);
        return <div>
        </div>
    }
    renderForm() {
        return <div className="nk-content ">
            <div className="container-fluid">
                <div className="nk-content-inner">
                    <div className="nk-content-body">
                        <div className="components-preview wide-md mx-auto">
                            <div className="nk-block nk-block-lg">
                                <div className="row g-4 mb-4">
                                    {!this.isEmpty(this.state.data.messages) && <div>
                                        {this.state.data.messages.map(msg => <div className={"col-lg-12 alert alert-pro " + (!msg.isAdmin ? "alert-warning rtl" : "alert-success rtl")}>
                                            <h6>{msg.userName}</h6>
                                            {(msg.messageFormat === 0 || msg.messageFormat === 1) && <div dangerouslySetInnerHTML={{ __html: msg.message }}></div>}
                                            {msg.messageFormat === 2 && this.showJsonMessage(msg)}
                                            <div>
                                                <small>تاریخ {msg.date}</small>
                                                {!this.isBlank(msg.attachmentPath) && <a style={{ "margin-right": "10px" }} target="_blank" href={msg.attachmentPath}>مشاهده فایل پیوست</a>}
                                            </div>
                                            {msg.isAdmin && <hr />}
                                            {msg.isAdmin && <p>در صورتیکه این پاسخ جوابگوی درخواست شما نبوده است، لطفا در ادامه همین تیکت پیگیری فرمایید . با تشکر</p>}
                                        </div>)}
                                    </div>}
                                </div>
                                <div className="card card-bordered">
                                    <div className="card-inner">
                                        <div className="card-head">
                                            <h5 className="card-title">محتوای پیام</h5>
                                        </div>
                                        <form method="post" onSubmit={e => this.save(e)} className="row g-4">
                                            {this.state.id === this.getDefaultGuid() && <div className="col-lg-12">
                                                <div className="form-group">
                                                    <label className="form-label">موضوع</label>
                                                    <div className="form-control-wrap">
                                                        <select className="form-control" defaultValue={this.state.data.record.topic} onChange={e => this.state.data.record.topic = parseInt(e.target.value)}>
                                                            <option value="0">انتخاب موضوع</option>
                                                            <option value="1">مشاوره آموزش</option>
                                                            <option value="2">مشاوره حضوری با مدیریت</option>
                                                            <option value="3">مربیگری - تدریس</option>
                                                            <option value="4">اختلال در خرید</option>
                                                            <option value="5">گواهینامه</option>
                                                            <option value="6">درخواست استخدام</option>
                                                            <option value="7">درخواست نیروی کار</option>
                                                            <option value="8">سایر موارد</option>
                                                            <option value="9">اختلال در سامانه مودیان</option>
                                                            <option value="10">نیاز / اختلال در ماژولهای مالی و اداری</option>
                                                            <option value="11">رزومه</option>
                                                            <option value="12">پرسش و سوال</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>}
                                            <div className="col-lg-12">
                                                <div className="form-group">
                                                    <label className="form-label">پیام شما</label>
                                                    <div className="form-control-wrap">
                                                        <textarea className="form-control" type="text" defaultValue={this.state.message} onChange={e => this.state.message = e.target.value}></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="form-group">
                                                    <label className="form-label">فایل پیوست</label>
                                                    <div className="form-control-wrap">
                                                        <input type="file" onChange={(e) => { this.setAttachment(e.target.files[0]) }} />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-lg-12">
                                                <div className="form-group">
                                                    <button type="submit" className="btn btn-lg btn-primary">ارسال پیام</button>
                                                    {this.state.id !== this.getDefaultGuid() && <a onClick={e => this.closeTicket()} className="ms-2 btn btn-lg btn-danger">بستن تیکت</a>}
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}